// extracted by mini-css-extract-plugin
export var bodySections = "_cf-8";
export var gray = "_cf-7";
export var green = "_cf-4";
export var iconContainer = "_cf-9";
export var iconWidgetContainer = "_cf-1";
export var phoneIcon = "_cf-2";
export var red = "_cf-5";
export var statusDot = "_cf-3";
export var widgetContainer = "_cf-0";
export var yellow = "_cf-6";